// extracted by mini-css-extract-plugin
export var answer = "PartnerFaqSection-module__answer___WhPrL";
export var answerText = "PartnerFaqSection-module__answerText___mv3Ud";
export var contextualStoreBackgroundDark = "#1a1b1e";
export var item = "PartnerFaqSection-module__item___dTBQy";
export var list = "PartnerFaqSection-module__list___BgXtk";
export var question = "PartnerFaqSection-module__question___pl6cO";
export var questionText = "PartnerFaqSection-module__questionText___mjN75";
export var section = "PartnerFaqSection-module__section___Mxvf3";
export var title = "PartnerFaqSection-module__title___DJemY";